// hooks/useAvatarUpdate.js
import { useState, useCallback } from "react";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { updateProfile } from "firebase/auth";

export function useAvatarUpdate(db, currentUser, navigate) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    const handleAvatarExported = useCallback(
        async (avatarUrl) => {
            if (loading) return;

            setLoading(true);
            setError(null);

            try {
                if (!avatarUrl || !avatarUrl.includes("readyplayer.me")) {
                    setError("Ungültige Avatar-URL"); // Fehler direkt setzen
                    return; // Verarbeitung abbrechen
                }

                const modelId = avatarUrl.split("/").pop()?.replace(".glb", "");
                if (!modelId || modelId.includes("/")) {
                    setError("Ungültige Model-ID"); // Fehler direkt setzen
                    return; // Verarbeitung abbrechen
                }

                const userDoc = await getDoc(doc(db, "users", currentUser.uid));
                if (!userDoc.exists()) {
                    setError("Benutzerprofil nicht gefunden"); // Fehler direkt setzen
                    return; // Verarbeitung abbrechen
                }

                const userData = userDoc.data();
                const updates = {
                    photoURL: `https://models.readyplayer.me/${modelId}.png`,
                    rpmModelUrl: `https://models.readyplayer.me/${modelId}.glb`,
                    hasRpmAvatar: true,
                    profilePath: userData.profilePath,
                };

                await updateDoc(doc(db, "users", currentUser.uid), updates);

                try {
                    await updateProfile(currentUser, { photoURL: updates.photoURL });
                } catch (authError) {
                    console.warn("Auth-Profil konnte nicht aktualisiert werden:", authError);
                }

                setSuccess("Avatar wurde erfolgreich gespeichert");
                setTimeout(() => {
                    navigate("/profil/" + userData.profilePath);
                }, 1500);
            } catch (err) {
                // Dieser Catch blockiert nur unerwartete Fehler
                setError(err.message);
            } finally {
                setLoading(false);
            }
        },
        [db, currentUser, navigate, loading]
    );

    return { handleAvatarExported, loading, error, success };
}